import { type RankingItem } from '../types';
import { ArrowRight } from 'lucide-react';

interface ComparisonViewProps {
  item1: RankingItem;
  item2: RankingItem;
  onSelect: (winnerId: string) => void;
  progress: number;
  totalComparisons: number;
  currentComparison: number;
}

export function ComparisonView({
  item1,
  item2,
  onSelect,
  progress,
  totalComparisons,
  currentComparison,
}: ComparisonViewProps) {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Progress Bar */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-[var(--text-sec)]">
            Comparison {currentComparison} of {totalComparisons}
          </span>
          <span className="text-sm font-medium text-[var(--text-sec)]">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full bg-[var(--hover-tint)] rounded-full h-2">
          <div
            className="bg-[var(--slate)] h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Comparison Cards */}
      <div className="mb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <button
            onClick={() => onSelect(item1.id)}
            className="group relative p-8 bg-[var(--bg-raised)] shadow-md border-2 border-[var(--rule)] hover:border-[var(--slate)] hover:shadow-lg transition-all duration-200 text-left"
          >
            <div className="absolute top-4 right-4 text-xs font-medium text-[var(--text-ter)] group-hover:text-[var(--text-ter)]">
              Click to select
            </div>
            <h3 className="text-2xl font-bold text-[var(--text-pri)] mb-2">{item1.name}</h3>
            <div className="mt-4 text-sm text-[var(--text-ter)]">
              <div>Score: {item1.score}</div>
              <div>Wins: {item1.wins} | Losses: {item1.losses}</div>
            </div>
          </button>

          <div className="hidden md:flex items-center justify-center">
            <ArrowRight className="h-8 w-8 text-[var(--text-ter)]" />
          </div>

          <button
            onClick={() => onSelect(item2.id)}
            className="group relative p-8 bg-[var(--bg-raised)] shadow-md border-2 border-[var(--rule)] hover:border-[var(--slate)] hover:shadow-lg transition-all duration-200 text-left"
          >
            <div className="absolute top-4 right-4 text-xs font-medium text-[var(--text-ter)] group-hover:text-[var(--text-ter)]">
              Click to select
            </div>
            <h3 className="text-2xl font-bold text-[var(--text-pri)] mb-2">{item2.name}</h3>
            <div className="mt-4 text-sm text-[var(--text-ter)]">
              <div>Score: {item2.score}</div>
              <div>Wins: {item2.wins} | Losses: {item2.losses}</div>
            </div>
          </button>
        </div>
      </div>

      <p className="text-center text-[var(--text-sec)] text-sm">
        Which item do you prefer? Click on the one you'd like to rank higher.
      </p>
    </div>
  );
}

